import { Injectable } from '@angular/core';
import { CustomerModel } from 'src/app/models/customer-model';
import { AffiliateTrackerInterface, AffiliateTrackerCallbackParams } from 'src/app/interfaces/affliation-interface';
import { GoogleService } from './google.service';

@Injectable({
    providedIn: 'root'
  })

export class GoogleTracker implements AffiliateTrackerInterface
{
    public customer: CustomerModel;
    protected configVars: any;
    protected params: any;
    
    constructor(
        private googleService: GoogleService,
    ) {  
    }
    
    initialize(): Promise<AffiliateTrackerInterface> {      
        this.googleService.setup();
        return Promise.resolve( this);
    }
    
    login( cbParams: AffiliateTrackerCallbackParams)
    {
        this.googleService.loginEvent(cbParams.customer_id);
    }
    signupStep1Complete( cbParams: AffiliateTrackerCallbackParams)
    {
        this.googleService.createAccountEvent(cbParams.customer_id);
    }

    signupComplete(cbParams: AffiliateTrackerCallbackParams)
    {
        this.googleService.createAccountCompleteEvent(cbParams);
    }

    deposit( cbParams: AffiliateTrackerCallbackParams)
    {
        this.googleService.depositEvent(cbParams);
    }

    withdraw( cbParams: AffiliateTrackerCallbackParams)
    {
        this.googleService.withdrawalEvent(cbParams);
    }

    gameLaunched( cbParams: AffiliateTrackerCallbackParams)
    {
        this.googleService.gameLaunched(cbParams);
    }

    sendPageHistoryEvent( cbParams: AffiliateTrackerCallbackParams)
    {
        this.googleService.sendPageHistoryEvent(cbParams);
    }

    loginError( cbParams: AffiliateTrackerCallbackParams)
    {
        this.googleService.loginError(cbParams);
    }

    forgotPassword( cbParams: AffiliateTrackerCallbackParams)
    {
        this.googleService.forgotPassword(cbParams);
    }

    betPlaced( cbParams: AffiliateTrackerCallbackParams)
    {
        this.googleService.betPlaced(cbParams);
    }

    conversion( cbParams: AffiliateTrackerCallbackParams)
    {
        this.googleService.conversion(cbParams);
    }

    logout( )
    {
        this.googleService.logout();;
    }

    gameClosed()
    {
        this.googleService.gameClosed();
    }
}
